import { render, staticRenderFns } from "./BaseInputPhone.vue?vue&type=template&id=2321bd70&scoped=true&"
import script from "./BaseInputPhone.vue?vue&type=script&lang=js&"
export * from "./BaseInputPhone.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputPhone.vue?vue&type=style&index=0&id=2321bd70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2321bd70",
  null
  
)

export default component.exports